import {Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {FormWrapper} from "../items/form.wrapper";
import {AbstractFormFieldComponent} from "../abstract-form-field.component";
import {ReactiveFormsModule} from "@angular/forms";

import {FormLabelComponent} from "../form-label/form-label.component";
import {FormFieldErrorComponent} from "../form-field-error/form-field-error.component";
import {Size} from "../../../base/data/size";
import {FormFileConfig} from "./form-file-config";
import {isDefined} from "../../utils/epic.utils";

@Component({
  selector: 'acc-form-file',
  imports: [
    ReactiveFormsModule,
    FormLabelComponent,
    FormFieldErrorComponent
  ],
  templateUrl: './form-file.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './form-file.component.css'
})
export class FormFileComponent extends AbstractFormFieldComponent {

  @ViewChild('input')
  public input: ElementRef | undefined;

  @Input({required: true})
  public name!: string;

  @Input({required: true})
  public wrapper!: FormWrapper;

  // Only Fallback - use config.accept
  @Input()
  public accept: string = 'image/png, image/jpeg';

  @Input()
  public config: FormFileConfig = new FormFileConfig();

  private file: File | undefined;

  public getFile(): File | undefined {
    return this.file;
  }

  protected override isViewOnly(): boolean {
    return this._isViewOnly(this.name, this.wrapper);
  }

  protected override getSize(): Size | undefined {
    return this.config.size;
  }

  protected onInputChange(event: Event): void {
    this.input?.nativeElement.blur();
    if (event.target instanceof HTMLInputElement && event.target.files && event.target.files.length > 0) {
      this.file = event.target.files[0];
      // The file input is not bound to the form control (see template), so selecting a file does not emit a
      // valueChange on its own. Push the file name into the control to trigger valueChanges -> auto-submit.
      this._onChangeValue(this.name, this.wrapper, this.file.name);
    }
  }

  protected isInvalid(): boolean {
    return this._isInvalid(this.name, this.wrapper);
  }

  protected getClass(): string {
    return isDefined(this.getSize()) ? 'form-control-' + this.getSize()?.value : '';
  }

  protected getAccept(): string {
    if (isDefined(this.config.accept)) {
      return this.config.accept;
    }
    return this.accept;
  }
}
